import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=79e97f35&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=79e97f35&prod&lang=scss"
import style1 from "./SiteHeader.vue?vue&type=style&index=1&id=79e97f35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e97f35",
  null
  
)

export default component.exports